export function formatApiErrorDetail(detail, fallback = '') {
  if (detail == null) return fallback;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail.map((e) => (e && e.msg != null ? e.msg : JSON.stringify(e))).join('\n') || fallback;
  }
  if (typeof detail === 'object') return JSON.stringify(detail);
  return String(detail) || fallback;
}

export function errorMessage(e, fallback) {
  return formatApiErrorDetail(e?.response?.data?.detail, '') || e?.message || fallback;
}

export function rowKey(row) {
  return `${row?.schema || ''} ${row?.table_name || ''} ${row?.column_name || ''}`;
}

export function sameRow(a, b) {
  return rowKey(a) === rowKey(b);
}

export function normalizeList(value) {
  if (!Array.isArray(value)) return [];
  return value.map((p) => String(p || '').trim()).filter(Boolean);
}

export function sameList(a, b) {
  const x = normalizeList(a);
  const y = normalizeList(b);
  return x.length === y.length && x.every((v, i) => v === y[i]);
}

export function samePathPrefix(path, prefix) {
  if (!Array.isArray(path) || !Array.isArray(prefix) || prefix.length > path.length) return false;
  return prefix.every((p, i) => path[i] === p);
}

export function formatNumber(n) {
  if (n == null || Number.isNaN(Number(n))) return '—';
  return Number(n).toLocaleString();
}

export function formatPercent(part, total) {
  if (!total) return '—';
  return `${Math.round((Number(part) / Number(total)) * 100)}%`;
}

export function formatDuration(ms) {
  if (ms == null || Number.isNaN(Number(ms))) return '';
  const total = Math.max(0, Math.round(Number(ms) / 1000));
  const m = Math.floor(total / 60);
  const s = total % 60;
  if (m === 0) return `${s}s`;
  return `${m}m ${String(s).padStart(2, '0')}s`;
}

export function formatDateTime(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return String(iso);
  const now = new Date();
  const sameDay = d.toDateString() === now.toDateString();
  const time = d.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' });
  if (sameDay) return `today ${time}`;
  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  if (d.toDateString() === yesterday.toDateString()) return `yesterday ${time}`;
  return `${d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' })}, ${time}`;
}

export function formatRelative(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const diff = Math.max(0, Date.now() - d.getTime());
  const min = Math.round(diff / 60000);
  if (min < 1) return 'just now';
  if (min < 60) return `${min} min ago`;
  const h = Math.round(min / 60);
  if (h < 24) return `${h} hr ago`;
  return formatDateTime(iso);
}

/** Case-insensitive de-duplicated tag list, trimmed. */
export function cleanTags(tags) {
  const seen = new Set();
  const out = [];
  normalizeList(tags).forEach((t) => {
    const key = t.toLowerCase();
    if (seen.has(key)) return;
    seen.add(key);
    out.push(t);
  });
  return out;
}
